import { SvgIcon, Icon } from '@tribeplatform/react-ui-kit/Icon'
import { Toggle } from '@tribeplatform/react-ui-kit/Toggle'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { T } from '../../i18n/components/T.js'

interface Props {
  label: string
  icon: JSX.Element
  checked: boolean
  handleChange: (enabled: boolean) => void
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

export const NonDraggableItem = ({
  label,
  icon,
  checked,
  handleChange,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: Props) => {
  return (
    <div className="flex items-center space-s-2">
      <div
        className="truncate flex-1 flex space-s-2 items-center border border-line-subdued rounded-base px-1 py-2 mb-2 bg-surface hover:bg-surface-hovered cursor-pointer"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="mx-1 text-content-subdued flex-shrink-0">
          <Tooltip>
            <Tooltip.Trigger>
              <SvgIcon name="lock" />
            </Tooltip.Trigger>
            <Tooltip.Panel>
              <T
                id="CommonComponents.NonDraggableItem.ItemCantBeMoved"
                defaultMessage="This item cannot be moved"
              />
            </Tooltip.Panel>
          </Tooltip>
        </div>
        {icon && <Icon className="w-5 h-5 shrink-0">{icon}</Icon>}
        <p className="flex-1 text-content-subdued text-sm truncate">{label}</p>
        <div className="flex space-s-1 items-center px-1">
          <div
            onClick={e => {
              e.stopPropagation()
            }}
          >
            <Toggle
              size="sm"
              checked={checked}
              onChange={() => {
                handleChange(!checked)
              }}
            />
          </div>
          <SvgIcon
            className="w-4 h-4 shrink-0 text-content-subdued rtl:-scale-x-100"
            name="chevron-right"
          />
        </div>
      </div>
    </div>
  )
}
